var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "notifications", attrs: { fluid: "" } },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center my-6" },
        [
          _c("div", [
            _c("h2", [_vm._v("Notifications")]),
            _c(
              "div",
              { staticClass: "text-body-2 grey--text text--darken-1 mt-1" },
              [_vm._v(" " + _vm._s(_vm.pageDescription) + " ")]
            ),
          ]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", depressed: "" },
              on: {
                click: function ($event) {
                  _vm.formDrawer = true
                },
              },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
              _vm._v(" New notification "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "notification-history-card mx-auto mb-6",
          attrs: { elevation: "2" },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "pt-6" },
            [
              _c("v-text-field", {
                staticClass: "mr-4",
                staticStyle: { "max-width": "280px" },
                attrs: {
                  "prepend-inner-icon": "mdi-magnify",
                  label: "Filter current page",
                  "single-line": "",
                  "hide-details": "",
                  dense: "",
                  outlined: "",
                },
                model: {
                  value: _vm.historySearch,
                  callback: function ($$v) {
                    _vm.historySearch = $$v
                  },
                  expression: "historySearch",
                },
              }),
              _c("v-spacer"),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    icon: "",
                                    loading: _vm.historyLoading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.fetchHistory({
                                        resetPage: true,
                                      })
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-refresh")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Refresh history")])]
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-0",
                attrs: {
                  headers: _vm.historyHeaders,
                  items: _vm.historyItems,
                  search: _vm.historySearch,
                  loading: _vm.historyLoading,
                  options: _vm.historyOptions,
                  "server-items-length": _vm.historyTotal,
                  "footer-props": { "items-per-page-options": [10, 25, 50] },
                },
                on: {
                  "update:options": function ($event) {
                    _vm.historyOptions = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.msg_title",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "text-truncate",
                            staticStyle: { "max-width": "280px" },
                          },
                          [_vm._v(_vm._s(item.msg_title))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.audience",
                    fn: function ({ item }) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.formatAudience(item)))]),
                      ]
                    },
                  },
                  {
                    key: "item.recipient_count",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              small: "",
                              outlined: "",
                              color: "primary",
                            },
                          },
                          [_vm._v(_vm._s(item.recipient_count))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.created_on",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDateTime(item.created_on)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.viewNotification(item)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-eye"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "no-data",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "py-6 text-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: { size: "48", color: "grey lighten-1" },
                              },
                              [_vm._v("mdi-bell-outline")]
                            ),
                            _c(
                              "div",
                              { staticClass: "text-body-2 grey--text mt-2" },
                              [_vm._v("No notifications have been sent yet.")]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-2",
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.formDrawer = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { left: "", small: "" } },
                                  [_vm._v("mdi-plus")]
                                ),
                                _vm._v(" Send your first notification "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "notification-form-drawer",
          attrs: { right: "", temporary: "", fixed: "", width: "560" },
          model: {
            value: _vm.formDrawer,
            callback: function ($$v) {
              _vm.formDrawer = $$v
            },
            expression: "formDrawer",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-column",
              staticStyle: { height: "100%" },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center px-5 py-4 drawer-header" },
                [
                  _c("span", { staticClass: "text-h6" }, [
                    _vm._v("New notification"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", disabled: _vm.loading },
                      on: { click: _vm.closeForm },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "div",
                { staticClass: "flex-grow-1 px-5 py-4 drawer-body" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "mb-3",
                        attrs: {
                          label: "Notification title",
                          dense: "",
                          required: "",
                          rules: _vm.titleRules,
                          "validate-on-blur": "",
                          outlined: "",
                          "hide-details": "auto",
                          counter: "100",
                        },
                        model: {
                          value: _vm.notification.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.notification, "title", $$v)
                          },
                          expression: "notification.title",
                        },
                      }),
                      _c("v-textarea", {
                        attrs: {
                          label: "Notification body",
                          dense: "",
                          required: "",
                          rules: _vm.messageRules,
                          "validate-on-blur": "",
                          outlined: "",
                          "hide-details": "auto",
                          counter: "500",
                          rows: "5",
                          "auto-grow": "",
                        },
                        model: {
                          value: _vm.notification.message,
                          callback: function ($$v) {
                            _vm.$set(_vm.notification, "message", $$v)
                          },
                          expression: "notification.message",
                        },
                      }),
                      _c("div", { staticClass: "mt-6 mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-subtitle-1 font-weight-medium",
                              },
                              [_vm._v("Audience")]
                            ),
                            _c("v-spacer"),
                            _c("v-checkbox", {
                              staticClass: "mt-0 pt-0",
                              attrs: {
                                label: "Send to all",
                                color: "primary",
                                dense: "",
                                "hide-details": "",
                              },
                              on: { change: _vm.onSendToAllChange },
                              model: {
                                value: _vm.sendToAll,
                                callback: function ($$v) {
                                  _vm.sendToAll = $$v
                                },
                                expression: "sendToAll",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-caption grey--text text--darken-1",
                          },
                          [_vm._v(" " + _vm._s(_vm.audienceCaption) + " ")]
                        ),
                      ]),
                      !_vm.sendToAll
                        ? _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              !_vm.storesOnlyAudience
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: "Sources",
                                          items: _vm.sources,
                                          rules: _vm.audienceRules,
                                          loading: _vm.loadingSources,
                                          disabled: _vm.loadingSources,
                                          "item-text": "text",
                                          "item-value": "value",
                                          "return-object": "",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          multiple: "",
                                          "small-chips": "",
                                          "deletable-chips": "",
                                          clearable: "",
                                        },
                                        on: { change: _vm.onTargetingChange },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { ripple: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSelectAll(
                                                            "selectedSources",
                                                            "sources"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-action",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm
                                                                    .selectedSources
                                                                    .length > 0
                                                                    ? "primary"
                                                                    : "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.selectAllSourcesIcon
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Select All"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-divider", {
                                                    staticClass: "mt-2",
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "selection",
                                              fn: function ({ item, index }) {
                                                return [
                                                  _vm.selectedSources.length < 3
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "audience-chip",
                                                          attrs: {
                                                            small: "",
                                                            close: "",
                                                          },
                                                          on: {
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeTargetItem(
                                                                  "selectedSources",
                                                                  index
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline-block text-truncate audience-chip-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : index === 0
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            label: "",
                                                            color: "primary",
                                                            outlined: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .selectedSources
                                                                  .length
                                                              ) +
                                                              " selected "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          748584210
                                        ),
                                        model: {
                                          value: _vm.selectedSources,
                                          callback: function ($$v) {
                                            _vm.selectedSources = $$v
                                          },
                                          expression: "selectedSources",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.storesOnlyAudience
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: "Store Groups",
                                          items: _vm.storeGroups,
                                          rules: _vm.audienceRules,
                                          loading: _vm.loadingStoreGroups,
                                          disabled: _vm.loadingStoreGroups,
                                          "item-text": "text",
                                          "item-value": "value",
                                          "return-object": "",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          multiple: "",
                                          "small-chips": "",
                                          "deletable-chips": "",
                                          clearable: "",
                                        },
                                        on: { change: _vm.onTargetingChange },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { ripple: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSelectAll(
                                                            "selectedStoreGroups",
                                                            "storeGroups"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-action",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm
                                                                    .selectedStoreGroups
                                                                    .length > 0
                                                                    ? "primary"
                                                                    : "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.selectAllIcon
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Select All"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-divider", {
                                                    staticClass: "mt-2",
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "selection",
                                              fn: function ({ item, index }) {
                                                return [
                                                  _vm.selectedStoreGroups
                                                    .length < 3
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "audience-chip",
                                                          attrs: {
                                                            small: "",
                                                            close: "",
                                                          },
                                                          on: {
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeTargetItem(
                                                                  "selectedStoreGroups",
                                                                  index
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline-block text-truncate audience-chip-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : index === 0
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            label: "",
                                                            color: "primary",
                                                            outlined: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .selectedStoreGroups
                                                                  .length
                                                              ) +
                                                              " selected "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          424924668
                                        ),
                                        model: {
                                          value: _vm.selectedStoreGroups,
                                          callback: function ($$v) {
                                            _vm.selectedStoreGroups = $$v
                                          },
                                          expression: "selectedStoreGroups",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    sm: _vm.storesOnlyAudience ? 12 : 6,
                                  },
                                },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: "Stores",
                                      items: _vm.stores,
                                      rules: _vm.audienceRules,
                                      loading: _vm.loadingStores,
                                      disabled: _vm.loadingStores,
                                      "item-text": "text",
                                      "item-value": "value",
                                      "return-object": "",
                                      dense: "",
                                      outlined: "",
                                      "hide-details": "auto",
                                      multiple: "",
                                      "small-chips": "",
                                      "deletable-chips": "",
                                      clearable: "",
                                    },
                                    on: { change: _vm.onTargetingChange },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-item",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: { ripple: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleSelectAll(
                                                        "selectedStores",
                                                        "stores"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color:
                                                              _vm.selectedStores
                                                                .length > 0
                                                                ? "primary"
                                                                : "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.selectAllStoresIcon
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v("Select All"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("v-divider", {
                                                staticClass: "mt-2",
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "selection",
                                          fn: function ({ item, index }) {
                                            return [
                                              _vm.selectedStores.length < 3
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      staticClass:
                                                        "audience-chip",
                                                      attrs: {
                                                        small: "",
                                                        close: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return _vm.removeTargetItem(
                                                              "selectedStores",
                                                              index
                                                            )
                                                          },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-inline-block text-truncate audience-chip-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.text)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : index === 0
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        label: "",
                                                        color: "primary",
                                                        outlined: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.selectedStores
                                                              .length
                                                          ) +
                                                          " selected "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3411235568
                                    ),
                                    model: {
                                      value: _vm.selectedStores,
                                      callback: function ($$v) {
                                        _vm.selectedStores = $$v
                                      },
                                      expression: "selectedStores",
                                    },
                                  }),
                                ],
                                1
                              ),
                              !_vm.storesOnlyAudience
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: "Departments",
                                          items: _vm.departments,
                                          rules: _vm.audienceRules,
                                          loading: _vm.loadingDepartments,
                                          disabled: _vm.loadingDepartments,
                                          "item-text": "name",
                                          "item-value": "id",
                                          "return-object": "",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          multiple: "",
                                          "small-chips": "",
                                          "deletable-chips": "",
                                          clearable: "",
                                        },
                                        on: { change: _vm.onTargetingChange },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { ripple: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSelectAll(
                                                            "selectedDepartments",
                                                            "departments"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-action",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm
                                                                    .selectedDepartments
                                                                    .length > 0
                                                                    ? "primary"
                                                                    : "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.selectAllDepartmentsIcon
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Select All"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-divider", {
                                                    staticClass: "mt-2",
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "selection",
                                              fn: function ({ item, index }) {
                                                return [
                                                  _vm.selectedDepartments
                                                    .length < 3
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "audience-chip",
                                                          attrs: {
                                                            small: "",
                                                            close: "",
                                                          },
                                                          on: {
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeTargetItem(
                                                                  "selectedDepartments",
                                                                  index
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline-block text-truncate audience-chip-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : index === 0
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            label: "",
                                                            color: "primary",
                                                            outlined: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .selectedDepartments
                                                                  .length
                                                              ) +
                                                              " selected "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1404679217
                                        ),
                                        model: {
                                          value: _vm.selectedDepartments,
                                          callback: function ($$v) {
                                            _vm.selectedDepartments = $$v
                                          },
                                          expression: "selectedDepartments",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasParties && _vm.selectedDepartments.length > 0
                        ? _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  { staticClass: "text-caption info--text" },
                                  [
                                    _vm._v(
                                      " Notification will go to users in these parties "
                                    ),
                                    _c("strong", [_vm._v("who are also")]),
                                    _vm._v(" opted into these departments. "),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c("div", { staticClass: "px-5 py-3 drawer-footer" }, [
                _c(
                  "div",
                  {
                    staticClass: "mb-3",
                    staticStyle: { "min-height": "24px" },
                  },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "recipient-count", mode: "out-in" } },
                      [
                        !_vm.hasTargeting
                          ? _c(
                              "div",
                              {
                                key: "empty",
                                staticClass: "text-caption grey--text",
                              },
                              [
                                _vm._v(
                                  " Select an audience to see recipient count. "
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                key: "filled",
                                staticClass: "d-flex align-center flex-wrap",
                              },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "font-weight-medium mr-2",
                                    attrs: {
                                      color: _vm.recipientChipColor,
                                      "text-color": _vm.recipientChipTextColor,
                                      outlined: _vm.recipientPreviewLoading,
                                      small: "",
                                      label: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [_vm._v(_vm._s(_vm.recipientCountIcon))]
                                    ),
                                    _vm._v(
                                      " " + _vm._s(_vm.recipientCountText) + " "
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-caption grey--text text--darken-1",
                                  },
                                  [
                                    _vm._v(
                                      " Estimate based on current audience; actual delivery may vary. "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          text: "",
                          disabled: _vm.loading || _vm.isFormPristine,
                        },
                        on: { click: _vm.resetForm },
                      },
                      [_vm._v(" Reset ")]
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-2",
                        attrs: { text: "", disabled: _vm.loading },
                        on: { click: _vm.closeForm },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          depressed: "",
                          loading: _vm.loading,
                        },
                        on: { click: _vm.validateAndSubmit },
                      },
                      [_vm._v(" Send notification ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-icon", { attrs: { left: "", color: "warning" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ]),
                  _vm._v(" Confirm Send Notification "),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("div", { staticClass: "text-body-1 mb-2" }, [
                    _vm._v(
                      " Are you sure you want to send this notification? "
                    ),
                  ]),
                  _c("v-divider", { staticClass: "my-3" }),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v("Title:")]),
                    _vm._v(" " + _vm._s(_vm.notification.title) + " "),
                  ]),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v("Message:")]),
                    _vm._v(" " + _vm._s(_vm.notification.message) + " "),
                  ]),
                  _vm.selectedSources.length > 0
                    ? _c("div", [
                        _c("strong", [_vm._v("Sources:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedSources.length) +
                            " selected "
                        ),
                      ])
                    : _vm._e(),
                  _vm.selectedStoreGroups.length > 0
                    ? _c("div", [
                        _c("strong", [_vm._v("Store Groups:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedStoreGroups.length) +
                            " selected "
                        ),
                      ])
                    : _vm._e(),
                  _vm.selectedStores.length > 0
                    ? _c("div", [
                        _c("strong", [_vm._v("Stores:")]),
                        _vm._v(
                          " " + _vm._s(_vm.selectedStores.length) + " selected "
                        ),
                      ])
                    : _vm._e(),
                  _vm.selectedDepartments.length > 0
                    ? _c("div", [
                        _c("strong", [_vm._v("Departments:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.selectedDepartments
                                .map((d) => d.name)
                                .join(", ")
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.recipientPreviewSupported &&
                  _vm.recipientCount !== null &&
                  !_vm.recipientPreviewError
                    ? _c("div", { staticClass: "mt-1" }, [
                        _c("strong", [_vm._v("Estimated recipients:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.recipientToAll
                                ? "All subscribers"
                                : _vm.recipientCount.toLocaleString()
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.loading },
                      on: { click: _vm.confirmSend },
                    },
                    [_vm._v(" Send ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.viewDialog,
            callback: function ($$v) {
              _vm.viewDialog = $$v
            },
            expression: "viewDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "text-h5" }, [
                    _vm._v("Notification Details"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.viewDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm.selectedNotification
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  { staticClass: "text-subtitle-2 grey--text" },
                                  [_vm._v("Title")]
                                ),
                                _c("div", { staticClass: "text-body-1 mt-1" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selectedNotification.msg_title
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                              _c(
                                "v-col",
                                { staticClass: "mt-4", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Message")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-body-1 mt-1",
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification.msg_body
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Audience")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-2 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatAudience(
                                              _vm.selectedNotification
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Recipients")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-2 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (
                                              _vm.selectedNotification
                                                .recipient_count || 0
                                            ).toLocaleString()
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Sent by")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-2 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification
                                              .created_by || "—"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Sent")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-2 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDateTime(
                                              _vm.selectedNotification
                                                .created_on
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.selectedNotification.to_group
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 grey--text",
                                        },
                                        [_vm._v("Audience details")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-caption mt-1",
                                          staticStyle: {
                                            "word-break": "break-all",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.selectedNotification
                                                  .to_group
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                { staticClass: "mt-4", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Notification ID")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption mt-1 grey--text text--darken-1",
                                      staticStyle: {
                                        "font-family": "monospace",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification
                                              .notification_id
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbarColor,
            timeout: _vm.snackbarTimeout,
            "multi-line": "",
            top: "",
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }